module.exports = __webpack_public_path__ + "static/pattern-design-10-bdd5eebb452b839e7f8cfa94bd99c3b1.jpg";